import ItemNoEdit from 'common/components/item/ItemNoEdit';
import { dateFormat } from 'common/helpers/dateHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

import LinkToProfile from './LinkToProfile';
import PackageSummaryTotals from './PackageSummaryTotals';

const NextClubPackage = (props) => {
  const { clubPackage, clubMembership, settings } = props;
  if (!clubPackage) {
    return null;
  }
  const subTotal = clubPackage.items.reduce(
    (total, item) => total + item.defaultQuantity * item.price,
    0
  );
  return (
    <>
      <LinkToProfile
        clubPackage={clubPackage}
        clubMembership={clubMembership}
      />
      <hr />
      <div className="c7-checkout-summary__title">
        Next shipment{' '}
        <span>{dateFormat(clubPackage.processDate, settings)}</span>
      </div>

      {renderMinMaxProducts(clubPackage)}
      {renderOrderValue(clubPackage, settings)}

      <div className="c7-cart-items c7-cart-items--club-shipment">
        {clubPackage.items.map((item) => {
          const newItem = item;
          newItem.quantity = item.defaultQuantity;
          if (newItem.quantity === 0) {
            return null;
          }
          return (
            <ItemNoEdit item={newItem} key={item.id} settings={settings} />
          );
        })}
      </div>
      <PackageSummaryTotals subTotal={subTotal} settings={settings} />
      <LinkToProfile
        clubPackage={clubPackage}
        clubMembership={clubMembership}
      />
    </>
  );
};

export default NextClubPackage;

const renderMinMaxProducts = (clubPackage) => {
  if (clubPackage.itemChoice !== 'User Can Choose') {
    return null;
  }
  if (
    !clubPackage.minQuantityInShipment ||
    clubPackage.minQuantityInShipment === 0
  ) {
    return null;
  }
  return (
    <div className="c7-checkout-summary__notes">
      Next shipment is a minimum of{' '}
      {renderBoldItem(clubPackage.minQuantityInShipment)}.
    </div>
  );
};

const renderOrderValue = (clubPackage, settings) => {
  if (clubPackage.itemChoice !== 'User Can Choose') {
    return null;
  }
  if (
    !clubPackage.minOrderValueOfShipment ||
    clubPackage.minOrderValueOfShipment === 0
  ) {
    return null;
  }
  return (
    <div className="c7-checkout-summary__notes">
      Next shipment is a minimum of{' '}
      <strong>
        {currencyFormat(clubPackage.minOrderValueOfShipment, settings)}
      </strong>
      .
    </div>
  );
};

const renderBoldItem = (itemCount) => {
  if (itemCount === 1) {
    return <strong>1 item</strong>;
  }
  return <strong>{itemCount} items</strong>;
};
